import React, { createContext, useState, useContext } from 'react';

// Create a context
const LoadingContext = createContext();

// Create a provider component
export const LoadingProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);

    return (
        <LoadingContext.Provider value={{ loading, setLoading }}>
            {children}
        </LoadingContext.Provider>
    );
};

// Create a custom hook to use the loading context
export const useLoading = () => {
    return useContext(LoadingContext);
};
